<template>
  <div>
    <el-button v-if="noFiles" type="danger">Нет загруженных файлов</el-button>
    <el-button v-if="uploadFiles" type="primary" @click="showModal">
      Перейти к загрузке файлов
    </el-button>
    <el-button v-if="viewFiles" type="warning" @click="showModal">
      Просмотреть файлы
    </el-button>
    <el-dialog
      :before-close="checkForm"
      :title="formNameDocument"
      :visible.sync="isShowModal"
      :width="isMobile ? '100%' : '80%'"
      top="50px"
      :append-to-body="true"
      :close-on-click-modal="false"
      class="upload-doc-modal"
      @opened="onDialogOpened"
    >
      <div class="statutory">
        <div class="statutory__handler">
          <ul class="help_upload">
            <li>Выберите файлы для загрузки и нажмите загрузить файлы.</li>
            <li>Дождитесь пока загружаемые файлы появятся в списке ниже</li>
          </ul>

          <upload-files
            :docunent-id="documentId"
            :pasted-file="pastedFile"
            @uploaded="uploaded"
            @startUpload="onStartUpload"
            @aborted="onAborted"
          />
          <list-uploaded-files
            v-if="issetDocument"
            :file-list="fileList"
            @getZip="getZip"
            @deleteOne="deleteOne"
            @deleteAll="deleteAll"
          />
        </div>
        <div class="statutory__catalog">
          <div>
            <div class="statutory__catalog-title">Пакет документов:</div>

            <div v-for="(value, key) in documentsHeaders" :key="key">
              <div class="statutory__catalog-subtitle">{{ value }}</div>
              <el-radio-group
                v-model="statutoryDocuments[key]"
                class="statutory__catalog-radio"
                size="mini"
                @change="wasChanged = true"
              >
                <el-radio-button label="present">Есть</el-radio-button>
                <el-radio-button label="absent">Нет</el-radio-button>
                <el-radio-button label="not_required">
                  Не требуется
                </el-radio-button>
              </el-radio-group>
            </div>
          </div>

          <el-button
            type="primary"
            size="mini"
            class="statutory__catalog-button"
            :disabled="!wasChanged"
            @click="handleStatutoryChanging"
          >
            Сохранить
          </el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { RepositoryFactory } from '@/api/RepositoryFactory'
import ListUploadedFiles from './ListUploadedFiles'
import UploadFiles from './UploadFiles'

const FileRepository = RepositoryFactory.get('file')
const DocumentRepository = RepositoryFactory.get('document')

export default {
  name: 'UploadStatutoryModal',
  components: { UploadFiles, ListUploadedFiles },
  props: {
    sourceId: {
      type: Number,
      default: 0,
    },
    dataEdit: {
      type: Object,
      default: () => {},
    },
    documentsList: {
      type: Object,
      default: () => ({}),
    },
    documentsHeaders: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      document: '',
      isShowModal: false,
      formNameDocument: '',
      pastedFile: null,

      radio1: '6',
      wasChanged: false,
    }
  },
  computed: {
    documentId() {
      return this.document ? this.document.id : 0
    },
    issetDocument() {
      return Boolean(this.document)
    },
    fileList() {
      return this.document ? this.document.files : []
    },
    countFiles() {
      return this.document?.files?.length || 0
    },
    noFiles() {
      // могут добавлять файлы ?
      return !this.canUpload && (!this.document || this.countFiles === 0)
    },
    viewFiles() {
      return this.document && this.document.files && this.document.files.length
    },
    uploadFiles() {
      return (
        this.canUpload &&
        this.document &&
        this.document.files &&
        this.countFiles === 0
      )
    },
    statutoryDocuments: {
      get() {
        return this.documentsList
      },
      set(val) {
        this.$emit('change-docs', val)
      },
    },
  },
  watch: {
    sourceId: {
      immediate: true,
      handler() {
        this.setDataForEdit()

        if (this.dataEdit) {
          this.formNameDocument = this.getDocumentByType(
            this.dataEdit.documentType,
          ).name
        }
      },
    },
  },
  methods: {
    canUpload() {
      return this.$canAction('uploadFilesAuto', this.userInfo)
    },
    deleteOne(data) {
      this.$confirm('Вы действительно хотите удалить файл' + data, 'Warning', {
        confirmButtonText: 'Да',
        cancelButtonText: 'Нет',
        type: 'warning',
      }).then(() => {
        const fordel = this.fileList.filter(item => item.link === data)

        if (fordel) {
          this.deleteApi(fordel[0])
        }
      })
    },
    deleteAll() {
      this.$confirm('Вы действительно хотите удалить все файлы', 'Warning', {
        confirmButtonText: 'Да',
        cancelButtonText: 'Нет',
        type: 'warning',
      }).then(() => {
        for (let key in this.fileList) {
          this.deleteApi(this.fileList[key])
        }
      })
    },
    deleteApi(file) {
      FileRepository.dellOne(file.id).then(() => {
        this.document.files = this.document.files.filter(
          item => file.id !== item.id,
        )
        this.$emit('ready', this.document)
      }) // TODO поймать ошибку например файл подтвержден
    },
    getZip() {
      this.downloadRegistry({
        path: DocumentRepository.getZipUrl(this.document.id),
        blank: 1,
      })
    },
    getApproveOneDoc(documents) {
      // если есть аппрув док то берем только его, если нет то берем первый попавшийся ибо все равно не будет правильного
      let documentItem

      for (let key in documents) {
        if (documentItem === undefined) {
          documentItem = documents[key]
        }
        if (documents[key].approve_status.length !== 0) {
          documentItem = documents[key]
        }
      }
      this.document = documentItem
      this.$emit('ready', this.document)
    },
    getDocuments() {
      // получить документ // если нету то создаем
      if (this.dataEdit.sourceId) {
        DocumentRepository.getDocument(
          this.dataEdit.sourceModelName,
          this.dataEdit.sourceId,
          this.dataEdit.documentType,
        )
          .then(response => {
            if (response.data.length) {
              this.getApproveOneDoc(response.data)
            } else if (this.$canAction('createDocAuto', this.userInfo)) {
              DocumentRepository.createDocument(
                this.dataEdit.sourceModelName,
                this.dataEdit.sourceId,
                this.getDocumentTypeIdByType(this.dataEdit.documentType),
              )
                .then(responseNewDoc => {
                  this.getDocuments()
                  this.$emit('created', responseNewDoc.data.id)
                })
                .catch(err => this.errHandler(err))
            }
          })
          .catch(err => this.errHandler(err))
      }
    },
    checkForm(done) {
      if (this.wasChanged) {
        this.$confirm(
          'Вы не сохранили изменения состояния документов. Всё равно закрыть?',
          'Внимание!',
          {
            confirmButtonText: 'Да',
            cancelButtonText: 'Отмена',
            type: 'warning',
          },
        ).then(() => {
          window.removeEventListener('paste', this.handlePaste)
          this.$emit('not-saved')
          this.wasChanged = false
          done()
        })
      } else {
        window.removeEventListener('paste', this.handlePaste)
        done()
      }
    },
    showModal() {
      this.isShowModal = true
    },
    uploaded(file) {
      this.fileList.unshift(file)
      this.pastedFile = null
      window.addEventListener('paste', this.handlePaste)
    },
    setDataForEdit() {
      this.getDocuments()
    },
    onDialogOpened() {
      window.addEventListener('paste', this.handlePaste)
    },
    handlePaste(ev) {
      const items = (ev.clipboardData || ev.originalEvent.clipboardData).items

      for (let i in items) {
        let item = items[i]

        if (item.kind === 'file') {
          let blob = item.getAsFile()
          let allowedFormats = ['image/jpeg', 'image/png']
          let isSize = blob.size / 1024 / 1024 < 15

          if (!allowedFormats.includes(blob.type)) {
            this.$alert(
              'Ошибка при загрузке файла ' + blob.name + '. Неверный формат',
            )
          }
          if (!isSize) {
            this.$alert(
              'Ошибка при загрузке файла ' + blob.name + '. Превышен размер',
            )
          }
          if (isSize && allowedFormats.includes(blob.type)) {
            this.pastedFile = blob
          }
        }
      }
    },
    onStartUpload() {
      window.removeEventListener('paste', this.handlePaste)
    },
    onAborted() {
      window.addEventListener('paste', this.handlePaste)
    },
    handleStatutoryChanging() {
      this.$emit('save-statutories')
      this.wasChanged = false
    },
  },
}
</script>

<style lang="sass">
.upload-doc-modal
  font-family: "Rubik", sans-serif
  .box-card
    z-index: 5000 !important
    position: fixed
    left: 0
    top: 0
    width: 20%
    background-color: white
  .help_upload
    padding-left: 10px !important
    color: #a5a5a5
    font-size: 15px
    font-family: "Rubik", sans-serif
  .help_upload li
    padding-top: 5px
  .el-alert--success
    font-weight: bold !important
    cursor: pointer !important

.statutory
  display: flex
  &__handler
    flex: 1
  &__catalog
    display: flex
    flex-direction: column
    justify-content: space-between
    width: 550px
    margin-left: 30px
    padding-left: 50px
    border-left: 2px solid #EBEEF5;
    &-title
      margin-bottom: 10px
      font-size: 16px
      color: #303133
    &-subtitle
      margin-bottom: 4px
      font-size: 14px
      font-weight: 500
      color: #606266
    &-radio
      margin-bottom: 16px
    &-button
      width: 92px

  .el-radio-button__orig-radio:checked[value="present"]+.el-radio-button__inner
    background: #67C23A
    border: 1px solid #67C23A
    box-shadow: -1px 0 0 0 #67C23A

  .el-radio-button__orig-radio:checked[value="absent"]+.el-radio-button__inner
    background: #F56C6C
    border: 1px solid #F56C6C
    box-shadow: -1px 0 0 0 #F56C6C

  .el-radio-button__orig-radio:checked[value="not_required"]+.el-radio-button__inner
    background: #A5A5A5
    border: 1px solid #A5A5A5
    box-shadow: -1px 0 0 0 #A5A5A5
</style>
